import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
    emits: ['share'],
    props: {
        showSelect: {
            type: Boolean,
            default: true
        },
        showShare: {
            type: Boolean,
            default: true
        },
        showManage: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        }
    },
    setup() {
        const expand = ref(false);
        const editList = [{
                label: 'Edit Profile',
                value: 'Profiles'
            }, {
                label: 'Users',
                value: 'Users'
            }, {
                label: 'Log Out',
                value: 'LogOut'
            }];
        const router = useRouter();
        const select = () => {
            expand.value = !expand.value;
        };
        const clickItem = (item) => {
            if (item.value === 'LogOut') {
                localStorage.removeItem('token');
                router.replace('/');
            }
            else {
                router.push(`/user?type=${item.value}`);
            }
        };
        return {
            expand,
            editList,
            select,
            clickItem
        };
    }
});
